// Precise sentence-level captions for the FERUM intro video
// Timestamps are in seconds and were aligned to the audio narration
export const CAPTIONS = [
  { start: 0.7, end: 5.2, text: "We all know that collaboration on structural steel projects can be a challenge." },
  { start: 5.2, end: 11.4, text: "Especially when it comes to coordination between engineered connection designs, detailing teams, project management, and fabrication." },
  { start: 11.4, end: 16.0, text: "As projects become more complex, that disconnect creates real operational pressure." },
  { start: 16.0, end: 19.2, text: "Estimating engineering effort becomes difficult," },
  { start: 19.2, end: 22.0, text: "connection coordination becomes harder to track," },
  { start: 22.0, end: 26.8, text: "and valuable time gets lost managing information instead of moving the project forward." },
  { start: 26.8, end: 34.6, text: "For fabricators, that inefficiency directly impacts schedule, visibility, and ultimately, profit margins." },
  { start: 35.5, end: 37.4, text: "Until now." },
  { start: 37.4, end: 40.2, text: "FERUM™ was built to address exactly that." },
  { start: 40.2, end: 44.8, text: "FERUM™ is a centralized platform built specifically for structural steel connection coordination," },
  { start: 44.8, end: 52.8, text: "allowing estimators, engineers, detailers, project managers, and fabrication teams to work from a single connected workflow." },
  { start: 52.8, end: 59.9, text: "Follow along as we walk you through the FERUM™ workflow." },
];

export const VIDEO_URL = "/ferum-intro.mp4";

export const NEXT_VIDEO_URL = "https://youtu.be/GJVIk0xxE2g?si=H4xLlg4OgR-SZ4H_";
